/**
 * Created by JackCui on 2022/10/11
 */

import {batchHandleUrl} from '../../../utils/url-handle.js'

const api = {
  // 批量查询被引用字段的信息
  getQuoteField: {
    url: '/apaas/field/getQuoteField',
    type: 'post'
  }
}

export default batchHandleUrl(api)
